import en from './en';

// English remains the fallback baseline; translated keys below override it.
const fr = {
  ...en,
  "언어": "Langue",
  "로그인": "Connexion",
  "로그아웃": "Déconnexion",
  "비밀번호": "Mot de passe",
  "서버 오류": "Erreur serveur",
  "로그인 실패: ": "Échec de connexion : ",
  "🔐 어드민 로그인": "🔐 Connexion admin",
  "유저 관리": "Gestion des utilisateurs",
  "테이블 관리": "Gestion des tables",
  "전광판": "Bandeau",
  "자산기록": "Historique des actifs",
  "결제관리": "Gestion des paiements",
  "라운지 관리": "Gestion du lounge",
  "공지 관리": "Gestion des annonces",
  "광고 관리": "Gestion des publicités",
  "검색": "Rechercher",
  "검색어를 입력하세요": "Saisissez un mot-clé",
  "새로고침": "Actualiser",
  "로딩 중...": "Chargement...",
  "로딩중...": "Chargement...",
  "불러오는 중…": "Chargement…",
  "불러오기 실패": "Échec du chargement",
  "데이터 없음": "Aucune donnée",
  "데이터가 없습니다.": "Aucune donnée disponible.",
  "표시할 기록이 없습니다.": "Aucun enregistrement à afficher.",
  "생성": "Créer",
  "생성 중...": "Création...",
  "생성 중…": "Création…",
  "생성 실패: ": "Échec de création : ",
  "생성 에러:": "Erreur de création :",
  "수정": "Modifier",
  "저장": "Enregistrer",
  "저장 중...": "Enregistrement...",
  "저장 실패": "Échec de l’enregistrement",
  "삭제": "Supprimer",
  "삭제 실패": "Échec de suppression",
  "삭제됨": "Supprimé",
  "취소": "Annuler",
  "닫기": "Fermer",
  "확인": "Confirmer",
  "복사": "Copier",
  "상태": "Statut",
  "상세": "Détails",
  "관리": "Gérer",
  "관리 상태": "Statut admin",
  "노출": "Visible",
  "노출중": "Visible",
  "비활성": "Désactivé",
  "활성": "Actif",
  "게시": "Publié",
  "게시 중": "Publication",
  "게시 상태": "Statut de publication",
  "만료": "Expiré",
  "만료일:": "Expire le :",
  "게시일:": "Publié le :",
  "예약": "Planifié",
  "예약 없음": "Aucune réservation",
  "상시": "Toujours",
  "미리보기": "Aperçu",
  "그룹 생성": "Créer un groupe",
  "그룹 이름": "Nom du groupe",
  "그룹명": "Nom du groupe",
  "그룹 노출(DisplaySet)": "Exposition du groupe (DisplaySet)",
  "테이블 그룹": "Groupe de table",
  "테이블 생성": "Créer une table",
  "테이블 목록": "Liste des tables",
  "테이블 미션": "Mission de table",
  "테이블 미션 설정": "Paramètres de mission de table",
  "Small Blind": "Small Blind",
  "Big Blind": "Big Blind",
  "Rake % (수수료율)": "Rake % (commission)",
  "라운지 포인트 %": "Points lounge %",
  "라운지 포인트 % (0~100)": "Points lounge % (0–100)",
  "라운지 포인트 지급률": "Taux de points lounge",
  "현재 라운지 포인트 %": "Points lounge actuels %",
  "startAt (시작)": "startAt (début)",
  "endAt (종료, 선택)": "endAt (fin, optionnel)",
  "시작": "Début",
  "종료": "Fin",
  "시작(로컬)": "Début (local)",
  "종료(로컬)": "Fin (local)",
  "시작일": "Date de début",
  "기간": "Période",
  "무한(30일 갱신)": "Infini (renouvellement 30 jours)",
  "24시간 반복": "Répéter toutes les 24 heures",
  "공지 작성/관리": "Créer/Gérer les annonces",
  "공지 제목": "Titre de l’annonce",
  "공지 본문": "Corps de l’annonce",
  "공지 수정": "Modifier l’annonce",
  "새 공지 작성": "Créer une nouvelle annonce",
  "광고 이미지 등록/관리": "Enregistrer/Gérer l’image publicitaire",
  "광고 수정": "Modifier la publicité",
  "새 광고 등록": "Nouvelle publicité",
  "광고 이미지": "Image publicitaire",
  "라운지 글": "Publication lounge",
  "라운지 글 목록": "Liste des publications lounge",
  "라운지 아이템": "Article lounge",
  "라운지 업로드": "Téléversement lounge",
  "라운지포인트": "Points lounge",
  "결제 영역": "Zone de paiement",
  "결제 옵션": "Options de paiement",
  "결제 옵션 추가": "Ajouter une option de paiement",
  "결제 완료": "Paiement terminé",
  "결제 항목": "Élément de paiement",
  "금액": "Montant",
  "수량": "Quantité",
  "미결제": "Non payé",
  "자산": "Actifs",
  "레이크백": "Rakeback",
  "일반 자산": "Actifs généraux",
  "라운지포인트": "Points lounge",
  "관리자 자산 표시 영역": "Zone de résumé des actifs admin",
  "나의 지갑 주소": "Mon adresse de portefeuille",
  "보내는 지갑": "Portefeuille expéditeur",
  "받는 지갑": "Portefeuille destinataire",
  "에이전트": "Agent",
  "에이전트로 생성": "Créer comme agent",
  "하위 계정 생성": "Créer un sous-compte",
  "하위 생성": "Créer un inférieur",
  "하위 {id}": "Inférieur {id}",
  "소속 유저": "Utilisateurs assignés",
  "소속유저": "Utilisateurs assignés",
  "상위 에이전트:": "Agent parent :",
  "수수료": "Commission",
  "수수료 수정": "Modifier la commission",
  "수수료 수정 실패": "Échec de modification de commission",
  "분배 비율": "Taux de distribution",
  "분배 비율(상대 %)": "Taux de distribution (relatif %)",
  "Country 필터": "Filtre pays",
  "Device 필터": "Filtre appareil",
  "동아시아": "Asie de l’Est",
  "동남아": "Asie du Sud-Est",
  "유럽": "Europe",
  "북미": "Amérique du Nord",
  "남미": "Amérique du Sud",
  "아프리카": "Afrique",
  "글로벌": "Global",
  "제목": "Titre",
  "본문": "Corps",
  "내용(message)": "Contenu (message)",
  "이미지": "Image",
  "이미지 URL": "URL de l’image",
  "업로드": "Téléverser",
  "업로드중...": "Téléversement...",
  "링크 열기": "Ouvrir le lien",
  "링크:": "Lien :",
  "인포카드": "Carte info",
  "하이라이트 포인트": "Point fort",
  "하이라이트 메세지": "Message en surbrillance",
  "프리셋 수정": "Modifier le préréglage",
  "배경 색상": "Couleur de fond",
  "배경 이미지 URL": "URL image de fond",
  "배경 타입": "Type de fond",
  "폰트스타일": "Style de police",
  "굵기": "Graisse",
  "색상": "Couleur",
  "표시명": "Nom affiché",
  "페이지": "Page",
  "페이지 크기": "Taille de page",
  "다음": "Suivant",
  "이전": "Précédent",
  "위로": "Haut",
  "아래로": "Bas",
  "펼치기": "Déplier",
  "개": "éléments",
  "건": "enregistrements",
  "명": "utilisateurs",
  "⚠️ 권한이 없습니다": "⚠️ Vous n’avez pas l’autorisation",
  "이 페이지에 접근할 수 있는 권한이 없습니다.": "Vous n’avez pas l’autorisation d’accéder à cette page.",
};

export default fr;
